import { Grid, IconButton, Switch, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {
  getWorkOrdersWithFilters,
  PermissionsEnum,
  ProcureVendor,
  WORK_ORDER_CREATION_STATUS,
  WorkOrder,
} from 'vendor-marketplace-shared-library';
import WorkOrderCard from '../../../components/work-orders/WorkOrderCard';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import useAuth from '../../../hooks/useAuth';

export default function ProcureVendorWorkOrderModule(props: { vendor: ProcureVendor }) {
  const { validateUserPermissions } = useAuth();
  const navigate = useNavigate();
  const [_, setSearchParams] = useSearchParams();

  const { data: workOrderData } = useQuery(getWorkOrdersWithFilters, {
    variables: {
      procureVendorIds: [props.vendor.id],
      creationStatus: WORK_ORDER_CREATION_STATUS.COMPLETE,
    },
  });

  return (
    <Grid item container direction={'column'} sx={styles.workOrderContainer} boxShadow={2}>
      {/*Title*/}
      <Grid item container sx={styles.centeredApart}>
        <Grid item>
          <Typography variant={'h6'}>Work Orders</Typography>
        </Grid>
        {validateUserPermissions([PermissionsEnum.WORK_ORDERS_CREATE]) && (
          <Grid item>
            <IconButton
              onClick={() => {
                navigate(`/create-work-order?workOrderVendorId=${props.vendor.id}`);
              }}
            >
              <AddIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>

      {/*Work Orders*/}
      <Grid container sx={styles.workOrderCardContainer}>
        {workOrderData?.getWorkOrdersWithFilters?.length > 0 ? (
          workOrderData?.getWorkOrdersWithFilters.map((workOrder: WorkOrder) => (
            <Grid item key={workOrder.id}>
              <WorkOrderCard
                workOrder={workOrder}
                onClick={() => navigate(`/work-orders/${workOrder.id}`)}
              />
            </Grid>
          ))
        ) : (
          <Grid item>
            <Typography>No work orders for this vendor yet.</Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

const styles = {
  centeredContainer: {
    alignItems: 'center',
  },
  centeredApart: {
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  workOrderContainer: {
    rowGap: 2,
    padding: 2,
    borderRadius: 2,
    backgroundColor: 'secondary.light',
  },
  workOrderCardContainer: {
    rowGap: 2,
    columnGap: 2,
    overflow: 'auto',
    maxHeight: '800px',
  },
};
